import { Component, Input, OnInit } from '@angular/core';
import { SecurityLayerService } from 'src/app/___LOGIC/__auth/security-layer.service';
import { NavigationService } from 'src/app/___LOGIC/__navigation/navigation.service';
import { TranslationService } from 'src/app/___LOGIC/___common/__language/translation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input() visibleBurger;
  @Input() showLogoImage;
  @Input() textLogo;
  @Input() logoClick;
  @Input() logoUrl;
  @Input() imageUrl;
  @Input() menuTabs;
  @Input() shoppingCart;
  @Input() visibleBack;
  @Input() visibleLogin;
  @Input() visibleDotsMenu;
  @Input() visibleRegister;
  @Input() visibleVideocall;
  @Input() visibleUserMenu;
  @Input() backRoute;
  
  constructor(private securityLayer: SecurityLayerService,private navigationService: NavigationService,private translationService: TranslationService) {}

  ngOnInit(): void {
    if(!this.showLogoImage){
      this.showLogoImage = true;
    }
    if(this.logoClick == undefined){
      this.logoClick = true;
    }
    if(!this.textLogo){
      this.textLogo = 'default';
    }
    if(!this.shoppingCart){
      this.shoppingCart = false;
    }
    if(this.visibleBack == null || this.visibleBack == undefined){
      this.visibleBack = this.navigationService.isHeaderButtonVisible('back');
    }
    if(this.visibleVideocall == null || this.visibleVideocall == undefined){
      this.visibleVideocall = false;
    }
    if(this.visibleDotsMenu == null || this.visibleDotsMenu == undefined){
      this.visibleDotsMenu = this.navigationService.isHeaderButtonVisible('dots');
    }
    // MENU BURGER
    if(this.visibleBurger == null || this.visibleBurger == undefined){
      this.visibleBurger = this.navigationService.isHeaderButtonVisible('burger');
    }
    // USE MENU
    if(this.visibleUserMenu == null || this.visibleUserMenu == undefined){
      this.visibleUserMenu = this.navigationService.isHeaderButtonVisible('userMenu');
    }

    // USE MENU
    if(this.visibleLogin == null || this.visibleLogin == undefined){
      this.visibleLogin = this.navigationService.isHeaderButtonVisible('login');
    }
    
    if(!this.imageUrl){
      this.imageUrl = 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/f31a0f71-80bd-4d22-d019-1e0832cc2300/public';
    }
    if(!this.logoUrl){
      this.logoUrl = '/app-home';
    }
  }

  isButtonVisible(buttonId){
    return this.navigationService.isHeaderButtonVisible(buttonId);
  }

  toggleMenu() {
    // Logic to toggle side menu if necessary
  }

  logout() {
    this.securityLayer.logout();
  }

  goBack(){
    this.navigationService.goBack();
  }

  goToPage(page){
    this.navigationService.navigateTo(page);
  }

  openDrive(){
    /* window.open(this.rootScope.getGoogleDriveUrl()); */
  }

  goToVideoCallCard(){
    this.navigationService.goToViewSection('/home','videocall60');
  }

  isVideocallPromoActive(){

  }

  getBurgerMenuItems(){
    return this.navigationService.getBurgerMenuItems();
  }

  getUserMenuItems(){
    return this.navigationService.getUserMenuItems();
  }

  showSpacer(){
    return this.navigationService.showSpacer();
  }

  toggleLanguage() {
    this.translationService.toggleLanguage();
  }

  getCurrentLanguage(){
    return this.translationService.getCurrentLanguage();
  }

  getTranslationFor(label){
    return this.translationService.getTranslatedText(label);
  }
}
